<template>
  <div class="c-app">
    <TheSidebar />
    <CWrapper>
      <TheHeader />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <CRow class="justify-content-center" v-if="![1,14,15].includes(this.$store.state.data.access_level)">
              <CCol md="12">
                <CAlert color="primary" closeButton>
                  <b>{{$store.state.data.company}}</b> عزیز به مرکز <a style="color: #1c578f;" target="_blank" href="https://hamkaran.cloud">تماس ابری همکاران</a> خوش آمدید✋.
                  <br>
                  از این که شمارو اینجا می‌بینیم بینهایت خوشحالیم😍.
                </CAlert>
              </CCol>
            </CRow>
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter />
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from "./TheSidebar";
import TheHeader from "./TheHeader";
import TheFooter from "./TheFooter";

export default {
  name: "TheContainer",
  components: {
    TheSidebar,
    TheHeader,
    TheFooter,
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
